import { HttpParams } from '@angular/common/http';
import { Component, OnInit, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SilkierLogMessageVm } from 'app/shared/generated/Silkier/Models/SilkierLogMessageVm';
import { ViewLogModalService } from './view-log-modal.service';
@Component({
    selector: 'pcg-view-log-modal',
    templateUrl: './view-log-modal.component.html',
    styleUrls: ['./view-log-modal.component.scss'],
    standalone: false
})
export class ViewLogModalComponent implements OnInit {
    private destroyRef = inject(DestroyRef);
    id: number;
    logMsg: string;
    constructor(public modal: NgbActiveModal, private viewLogModalService: ViewLogModalService ) { }
    ngOnInit() { this.getLog(); }
    public getLog() {
        const httpParams = new HttpParams().set('fireInstanceId', this.id);
        this.viewLogModalService.getLog(httpParams).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((resp: SilkierLogMessageVm) => {
            if (resp != null) { this.logMsg =  resp.logMessage; }
        });
    }
}
